<template>
  <v-app>
    <v-app-bar flat>
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <!-- <v-toolbar-title>e-Exam</v-toolbar-title> -->
      <v-btn
        text
        @click="dialogQuestionSelector = !dialogQuestionSelector"
        color="rgba(0, 0, 0, 0.54)"
      >
        <v-icon left>fas fa-bars</v-icon>รายการข้อสอบ
        <span
          v-if="undoneTotal > 0"
          style="
            margin: 2px 0 0 8px;
            font-weight: normal;
            color: #ce4257;
            font-size: 0.75rem;
          "
          >( {{ undoneTotal }} ข้อยังไม่ได้ทำ )</span
        >
        <span
          v-if="undoneTotal === 0"
          style="
            margin: 2px 0 0 8px;
            font-weight: normal;
            color: #737e8a;
            opacity: 0.75;
            font-size: 0.75rem;
          "
          >( ทำครบทุกข้อแล้ว )</span
        >
      </v-btn>

      <v-toolbar-title v-show="hasTimer && !readonlyMode && showTimer">
        <timer ref="timerBar" @expire="onExpire"></timer>
      </v-toolbar-title>
      <v-toolbar-title v-show="hasTimer && !readonlyMode && showPublishDate">
        <publishDate ref="publishDateBar" @expire="onExpire"></publishDate>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text @click="endExam" color="success" v-if="!readonlyMode">
        <v-icon left>far fa-check</v-icon>สิ้นสุดการทำแบบทดสอบ
      </v-btn>
    </v-app-bar>

    <v-main>
      <question-selector
        :isOpen.sync="dialogQuestionSelector"
        :questions="questionListForSelector"
        :questionsList="questionListAll"
        @onSelect="onChangeQuestion"
      ></question-selector>

      <v-row
        class="ma-0"
        :class="[$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-9']"
      >
        <v-col cols="12" sm="12" md="8" lg="6" class="question-block">
          <v-skeleton-loader
            class="mb-6"
            type="image, article"
            v-if="currentQuestion == null || showSkeleton"
          ></v-skeleton-loader>
          <div
            v-if="currentQuestion != null && showSkeleton == false"
            style="position: relative"
          >
            <div v-if="currentQuestion.typeQuestion == 'single'">
              <single-choice-exam
                ref="questionComp"
                :src="currentQuestion"
                :userAnswer="currentAnswer"
                :correctAnswer="correctAnswer"
                @interact="onInteract"
                :indicator="indicator"
              ></single-choice-exam>
            </div>
            <div v-else-if="currentQuestion.typeQuestion == 'multiple'">
              <multiple-choice-exam
                ref="questionComp"
                :src="currentQuestion"
                :userAnswer="currentAnswer"
                :correctAnswer="correctAnswer"
                :indicator="indicator"
                @interact="onInteract"
              ></multiple-choice-exam>
            </div>
            <div v-else-if="currentQuestion.typeQuestion == 'fillgaptext'">
              <complement-exam
                ref="questionComp"
                :src="currentQuestion"
                :userAnswer="currentAnswer"
                :correctAnswer="correctAnswer"
                :indicator="indicator"
                @interact="onInteract"
              ></complement-exam>
            </div>
            <div v-else-if="currentQuestion.typeQuestion == 'matchsome'">
              <matching-exam
                ref="questionComp"
                :src="currentQuestion"
                :userAnswer="currentAnswer"
                :correctAnswer="correctAnswer"
                :indicator="indicator"
                @interact="onInteract"
              ></matching-exam>
            </div>
            <div v-else-if="currentQuestion.typeQuestion == 'wordsearch'">
              <word-search-puzzle
                ref="questionComp"
                :src="currentQuestion"
                :userAnswer="currentAnswer"
                :correctAnswer="correctAnswer"
                :indicator="indicator"
                @interact="onInteract"
              ></word-search-puzzle>
            </div>
            <div v-else-if="currentQuestion.typeQuestion == 'memorygame'">
              <memory-game
                ref="questionComp"
                :src="currentQuestion"
                :userAnswer="currentAnswer"
                :correctAnswer="correctAnswer"
                :indicator="indicator"
                @interact="onInteract"
              ></memory-game>
            </div>
            <div v-else-if="currentQuestion.typeQuestion == 'crossword'">
              <crossword-puzzle
                ref="questionComp"
                :src="currentQuestion"
                :userAnswer="currentAnswer"
                :correctAnswer="correctAnswer"
                :indicator="indicator"
                @interact="onInteract"
              ></crossword-puzzle>
            </div>
            <div v-else>ไม่สามารถแสดงผลคำถามประเภทนี้ได้</div>
            <!-- <div v-else-if="currentQuestion.typeQuestion == 'article'">
          <article-exam ref="questionComp" :src="currentQuestion"></article-exam>
            </div>-->
            <v-btn icon @click="prev()" :disabled="isFirst" class="prev-btn">
              <v-icon>far fa-chevron-left</v-icon>
            </v-btn>

            <v-btn icon @click="next()" :disabled="isLast" class="next-btn">
              <v-icon>far fa-chevron-right</v-icon>
            </v-btn>

            <div class="btn-group mt-6">
              <v-btn
                depressed
                :disabled="!saveable"
                @click="saveAnswer"
                v-if="!readonlyMode"
                color="primary"
                large
                >ส่งคำตอบ</v-btn
              >

              <v-btn depressed @click="goSummaryPage()" v-if="readonlyMode">
                <v-icon left>far fa-file-chart-line</v-icon>สรุปการทดสอบ
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-overlay v-model="doProcess" class="text-center" :opacity="0.8">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
        <div class="my-4 white--text title">{{ processMsg }}</div>
      </v-overlay>

      <v-dialog v-model="dialogSaveChanges" persistent max-width="400">
        <v-card>
          <v-card-title>บันทึกคำตอบ ?</v-card-title>
          <v-card-text
            >ท่านกำลังจะเปลี่ยนแบบทดสอบ โดยที่ยังไม่บันทึกคำตอบ
            ท่านต้องการที่จะบันทึกคำตอบหรือไม่</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="skipQuestion">ไม่</v-btn>
            <v-btn text color="primary" @click="saveBeforeChange">ตกลง</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogTimerExpire" persistent max-width="400">
        <v-card>
          <v-card-title class="red--text">หมดเวลา</v-card-title>
          <v-card-text>สิ้นสุดเวลาทำแบบทดสอบ</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="summary(summaryDetail)">ดำเนินการต่อ</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogLastQuestion" persistent max-width="400">
        <v-card>
          <v-card-title class="red--text">หมดเวลา</v-card-title>
          <v-card-text
            >คำถามข้อสุดท้าย
            ท่านต้องการบันทึกและสิ้นสุดการทำแบบทดสอบเลยหรือไม่</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="summary">ดำเนินการต่อ</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmEnd" persistent max-width="400">
        <v-card>
          <v-card-title>สิ้นสุดการทำแบบทดสอบ</v-card-title>
          <v-alert type="warning" tile v-show="!allDone"
            >คุณยังตอบคำถามไม่ครบทุกข้อ</v-alert
          >
          <v-alert type="success" tile v-show="allDone"
            >คุณตอบคำถามครบทุกข้อแล้ว</v-alert
          >
          <v-card-text
            >คุณต้องการที่จะสิ้นสุดการทำแบบทดสอบ...ใช่หรือไม่</v-card-text
          >
          <v-card-actions>
            <v-btn text color="primary" @click="!allDone?summary('confirmEndWithOutAllDone'):summary('confirmEnd')">ใช่</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogConfirmEnd = false">ยกเลิก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="internalBrowser" fullscreen hide-overlay>
        <v-card tile>
          <v-toolbar dense color="primary" dark flat>
            <v-btn dark icon @click="closeInternalBrowser">
              <v-icon>far fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="caption pl-0"
              >URL: {{ internalBrowserUrl }}</v-toolbar-title
            >
          </v-toolbar>
          <v-row class="fill-height">
            <iframe
              :src="internalBrowserUrl"
              frameborder="0"
              height="100%"
              width="100%"
              style="height: calc(100vh - 48px)"
            ></iframe>
          </v-row>
        </v-card>
      </v-dialog>
    </v-main>

    <!-- <v-bottom-navigation color="primary" dark horizontal app height="48"></v-bottom-navigation> -->
    <v-bottom-sheet v-model="moreMenu">
      <v-list>
        <v-subheader>เมนู</v-subheader>
        <v-list-item @click="endExam">
          <v-list-item-icon>
            <v-icon color="green">far fa-file-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>สิ้นสุด</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>

    <v-dialog max-width="400" persistent v-model="dialogRequireScan">
      <v-card>
        <v-card-title>การตรวจสอบใบหน้า</v-card-title>
        <v-card-text>
          <template v-if="alertVerifyNotDone">
            <v-alert text type="warning">
              <strong>คำเตือน!</strong>
              <div>กรุณาสแกนใบหน้าของท่านในแอปฯ</div>
            </v-alert>
          </template>
          <template v-if="alertFakeUploadErr">
            <v-alert text type="error">
              <strong>คำเตือน!</strong>
              <div>เกิดข้อผิดพลาดในการข้ามขั้นตอนนี้ โปรดลองใหม่อีกครั้ง</div>
            </v-alert>
          </template>

          <p class="mb-4">
            กรุณาเปิดแอปฯในโทรศัพท์มือถือ
            และเข้าไปยังหน้าจอรายละเอียดข้อสอบชุดนี้ที่ท่านทำอยู่
            เพื่อสแกนใบหน้า แล้วทำการกด "ฉันสแกนแล้ว"
          </p>
          <v-btn
            block
            color="primary"
            @click="verifyFaceScanning"
            :loading="progressVerifyFaceScan"
            :disabled="progressFakeUpload"
          >
            ฉันสแกนแล้ว
          </v-btn>

          <div class="d-flex my-2 align-center">
            <div class="flex-grow-1">
              <v-divider></v-divider>
            </div>
            <div class="px-4">หรือ</div>
            <div class="flex-grow-1">
              <v-divider></v-divider>
            </div>
          </div>
          <div class="">
            <div class="d-flex justify-space-between align-center">
              <div>ไม่ได้ติดตั้งแอปฯในมือถือ</div>
              <div>
                <v-btn
                  @click="skipScan"
                  color="grey lighten-3"
                  small
                  depressed
                  :loading="progressFakeUpload"
                  >ข้าม
                  <v-icon right>fas fa-forward</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="mt-2">
              <span class="body-2 orange--text">
                <strong>คำเตือน!</strong> ถ้าท่านข้ามขั้นตอน "การตรวจสอบใบหน้า"
                ที่แอปฯในโทรศัพท์มือถือ ท่านจะถูกพิจารณาโดยครูผู้สอนในภายหลัง
              </span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="connectionQuestionErr" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{errorTitle}}</v-card-title>
          <v-card-text>{{errorDetail}}</v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-10 ma-2"
            color="success"
            dark
            @click="confirmRetryQuestion"
            >ตกลง</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="connectionSendAnswerErr" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{errorTitle}}</v-card-title>
          <v-card-text>{{errorDetail}}</v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-10 ma-2"
            color="success"
            dark
            @click="confirmRetrySendAnswer"
            >ตกลง</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="connectionStateErr" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{errorTitle}}</v-card-title>
          <v-card-text>{{errorDetail}}</v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-10 ma-2"
            color="success"
            dark
            v-if="!canReturnToCourse"
            @click="confirmRetryStateErr"
            >ตกลง</v-btn
          >
          <v-btn
            class="px-10 ma-2"
            color="success"
            dark
            v-else
            @click="closeWebView"
            >ตกลง</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import EventBus from "@/event-bus";
import Timer from "@/components/Timer.vue";
import publishDate from "@/components/PublishDate.vue";
import SingleChoiceExam from "@/components/SingleChoiceExam.vue";
import MultipleChoiceExam from "@/components/MultipleChoiceExam.vue";
import ComplementExam from "@/components/ComplementExam.vue";
import MatchingExam from "@/components/MatchingExam.vue";
import ArticleExam from "@/components/ArticleExam.vue";
import QuestionSelector from "@/components/QuestionSelector.vue";
import WordSearchPuzzle from "@/components/games/WordSearchPuzzle.vue";
import MemoryGame from "@/components/games/MemoryGame.vue";
import CrosswordPuzzle from "@/components/games/CrosswordPuzzle.vue";

var promiseRetry = require("promise-retry");

export default {
  components: {
    Timer,
    SingleChoiceExam,
    MultipleChoiceExam,
    ComplementExam,
    MatchingExam,
    ArticleExam,
    QuestionSelector,
    WordSearchPuzzle,
    MemoryGame,
    CrosswordPuzzle,
    publishDate
  },
  data: () => ({
    requiredScanData: null,
    alertFakeUploadErr: false,
    progressFakeUpload: false,
    progressVerifyFaceScan: false,
    dialogRequireScan: false,
    alertVerifyNotDone: false,
    moreMenu: false,
    dialogSaveChanges: false,
    dialogSaveChanges_source: "",
    dialogSaveChanges_value: null,
    showTimer: false, //show timer
    timerConfig: {
      start: 0,
      end: 0,
    },
    publishDate: {
      currtime: 0,
      endPublished: 0
    },
    showSkeleton: false,
    dialogQuestionSelector: false,
    examState: null,
    readonlyMode: false,
    themeColor: "primary",
    hasTimer: true,
    current: 0,
    doProcess: false,
    processMsg: "กรุณารอสักครู่",
    questionList: [],
    questionListForSelector: [],
    saveable: false,
    dialogTimerExpire: false,
    dialogLastQuestion: false,
    alreadySave: false,
    dialogConfirmEnd: false,
    skipWithoutShowAnswer: false,
    correctAnswer: null,
    questionListAll: [],
    internalBrowser: false,
    internalBrowserUrl: "",
    token: null,
    ticket: null,
    connectionStateErr: false,
    connectionSendAnswerErr: false,
    connectionQuestionErr: false,
    idx: null,
    errorDetail: "",
    errorTitle: "",
    firstLoadQuestionSuccess: false,
    firstLoadStateSuccess: false,
    canReturnToCourse: false,
    showPublishDate: false,
    summaryDetail:""
  }),
  mounted() {
    // const token = this.$route.query.token;
    let ticketDetail = this.$store.getters.getTicket;

    this.token = ticketDetail.token || this.$route.query.token;
    this.ticket = ticketDetail.ticket || this.$route.params.id;

    if (!ticketDetail.ticket) {
      let ticketDetail = {
        ticket: this.ticket,
        token: this.token,
      };
      this.$store.commit("setTicket", ticketDetail);
    }

    if (this.token != null) {
      this.$store.commit("setToken", this.token);
      const customTheme = this.$route.query.color;
      if (customTheme) {
        this.$vuetify.theme.themes.light.primary = "#" + customTheme;
      }

      this.getState();
      this.getQuestionList();
    } else {
      this.$router.replace({
        name: "error",
        params: {
          code: "0x002",
        },
      });
    }
    // if (this.$store.state.token == null) {
    //   this.$store.commit("setToken", this.$store.state.demoToken);
    // }

    // EventBus.$on("next", () => {
    //   this.nextQuestion();
    // });
    // EventBus.$on("prev", () => {
    //   this.prevQuestion();
    // });

    EventBus.$on("internalBrowser", (url) => {
      // this.internalBrowserUrl = url;
      // this.internalBrowser = true;
      this.openExternalBrowser(url);
    });
    this.handleResize();
  },
  beforeDestroy() {
    // EventBus.$off("next");
    // EventBus.$off("prev");
    EventBus.$off("internalBrowser");
  },
  watch: {
    doProcess(val) {
      this.processMsg = "กรุณารอสักครู่";
    },
    dialogRequireScan(val) {
      if (!val) {
        this.alertVerifyNotDone = false;
      }
    },
  },
  computed: {
    isFirst() {
      let result = false;
      if (this.examState != null && this.questionList.length > 0) {
        let idx = this.questionList.findIndex(
          (x) => x.question == this.examState.question._id
        );
        if (idx == 0) {
          result = true;
        }
      }
      return result;
    },
    isLast() {
      let result = false;
      if (this.examState != null && this.questionList.length > 0) {
        let idx = this.questionList.findIndex(
          (x) => x.question == this.examState.question._id
        );
        if (idx == this.questionList.length - 1) {
          result = true;
        }
      }
      return result;
    },
    // readOnly() {
    //   return this.$store.state.readOnly;
    // },
    indicator() {
      if (this.examState != null) {
        const idx = this.questionList.findIndex(
          (x) => x.question === this.examState.question._id
        );
        return `${idx + 1 || 0}/${this.questionList.length || 0}`;
      }
      return "0/0";
    },
    currentQuestion() {
      if (this.examState != null) {
        return this.examState.question;
      }
      return null;
    },
    currentAnswer() {
      if (this.examState != null) {
        const type = this.examState.question.typeQuestion;
        if (type == "fillgaptext") {
          if (this.examState.answer.answerText != null) {
            return this.examState.answer.answerText;
          }
        } else if (type == "single" || type == "multiple") {
          if (this.examState.answer.answer != null) {
            return this.examState.answer.answer;
          }
        } else if (type == "memorygame") {
          if (this.examState.answer.answerMemoryGame != null) {
            return this.examState.answer.answerMemoryGame;
          }
        } else if (type == "crossword" || type == "wordsearch") {
          if (this.examState.answer.answerPuzzleGrid != null) {
            return this.examState.answer.answerPuzzleGrid;
          }
        } else {
          if (this.examState.answer.answerMatch != null) {
            return this.examState.answer.answerMatch;
          }
        }
      }
      return null;
    },
    allDone() {
      let result = false;
      if (
        this.questionList.length > 0 &&
        this.questionList.findIndex((x) => x.state == null) == -1
      ) {
        result = true;
      }
      return result;
    },
    undoneTotal() {
      return this.questionListForSelector.filter((x) => x.state == null).length;
    },
    // saveable() {
    //   if (this.$refs.questionComp) {
    //     var userAnswer = this.$refs.questionComp.getAnswer();
    //     if (userAnswer != null) {
    //       return true;
    //     }
    //   }

    //   return false;
    // }
  },
  methods: {
    skipScan() {
      // call fake upload
      this.progressFakeUpload = true;
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      // get first job
      const payload = {
        idticket: this.ticket,
        priority: this.requiredScanData[0].priority,
        questionId: this.requiredScanData[0].questionId,
      };
      this.$http
        .post(
          `${this.$store.state.api}/faceRecognization/upload/fake`,
          payload,
          config
        )
        .then((resp) => {
          if (resp.data === true) {
            // it's done
            this.requiredScanData = null;
            this.dialogRequireScan = false;
          } else {
            // not done yet
            this.alertFakeUploadErr = true;
          }
        })
        .catch((err) => {
          // service error
        })
        .finally(() => {
          this.progressFakeUpload = false;
        });
    },
    verifyFaceScanning() {
      this.progressVerifyFaceScan = true;
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      this.$http
        .get(
          `${this.$store.state.api}/faceRecognization/job/is-done?ticket=${this.ticket}`,
          config
        )
        .then((resp) => {
          if (resp.data === true) {
            // it's done
            this.requiredScanData = null;
            this.dialogRequireScan = false;
          } else {
            // not done yet
            this.alertVerifyNotDone = true;
          }
        })
        .catch((err) => {
          // service error
        })
        .finally(() => {
          this.progressVerifyFaceScan = false;
        });
    },
    handleResize() {
      setTimeout(() => {
        if (window.innerWidth < 1264) {
          this.dialogQuestionSelector = false;
        }
      }, 500);
    },
    openExternalBrowser(url) {
      if (typeof externalBrowser !== "undefined") {
        externalBrowser.postMessage(url);
      } else {
        window.open(url, "_blank");
      }
    },
    closeInternalBrowser() {
      this.internalBrowserUrl = "";
      this.internalBrowser = false;
    },
    endExam() {
      this.moreMenu = false;
      this.dialogConfirmEnd = true;
      this.$store.commit("setEverClickDone", false);
    },
    onShowCorrectAnswerError() {},
    callShowAnswer() {
      this.processMsg = "กำลังเฉลย";
      this.doProcess = true;

      const ticket = this.ticket;
      let service = `${this.$store.state.api}/showCorrect?idquestion=${this.examState.question._id}&ticket=${ticket}`;
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      this.$http
        .get(service, config)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200 && resp.data.status == true) {
            // set to correct answer
            this.correctAnswer = resp.data.result;
            // if (
            //   this.examState.question.typeQuestion == "single" ||
            //   this.examState.question.typeQuestion == "multiple"
            // ) {
            //   this.correctAnswer = resp.data.result.correct;
            // } else if (this.examState.question.typeQuestion == "fillgaptext") {
            //   this.correctAnswer = resp.data.result.correctText;
            // } else if (this.examState.question.typeQuestion == "matchsome") {
            //   this.correctAnswer = resp.data.result.correctMatch;
            // } else {
            //   this.correctAnswer = null;
            // }
          } else {
            // call err state
            this.onShowCorrectAnswerError();
          }
        })
        .catch((err) => {
          // go to error page
          console.log(err);
          this.onShowCorrectAnswerError();
        })
        .finally(() => {
          this.doProcess = false;
        });
    },
    onInteract(e) {
      // console.log(e);

      if (this.$hasAnswer(this.examState.question.typeQuestion, e.answer)) {
        this.saveable = true;
      } else {
        this.saveable = false;
      }
    },
    onChangeQuestion(q) {
      if (this.examState.summaryAns == true || this.alreadySave) {
        this.getState(q.priority);
      } else {
        this.detectChanges("selector", q.priority);
      }
    },
    onExpire(timeOutBy) {
      // clear config
      this.clearTimer();
      // on expire
      this.dialogTimerExpire = true;
      this.summaryDetail = timeOutBy
      //alert("show ok dialog and then call summary");
    },
    setTimer() {
      this.timerConfig.start = this.examState.currtime;
      this.timerConfig.end = this.examState.endtime;
      this.showTimer = this.examState.endtime > 0 ? true : false;
      if(this.examState.endtime == 0 && this.examState.publishDate.endPublished > 0){
        this.showPublishDate = true
        this.publishDate.currtime = this.examState.currtime
        this.publishDate.endPublished = this.examState.publishDate.endPublished
      }
      this.$store.commit("setEndPublishDate", this.examState.publishDate.endPublished);
      // console.log(
      //   this.examState.endtime,
      //   this.examState.endtime > 0,
      //   this.examState.endtime > 0 ? true : false
      // );
      this.hasTimer = true;
      this.$refs.timerBar.startTimer(this.timerConfig);
      this.$refs.publishDateBar.startTimer(this.publishDate);
    },
    clearTimer() {
      this.timerConfig.start = 0;
      this.timerConfig.end = 0;
      this.publishDate.currtime = 0;
      this.publishDate.endPublished = 0;
      this.$refs.timerBar.cancelTimer();
      this.$refs.publishDateBar.cancelTimer();
      this.showTimer = false;
      this.hasTimer = false;
      this.showPublishDate = false
    },
    getState(idx, evt) {
      this.correctAnswer = null;
      this.alreadySave = false;
      this.saveable = false;
      this.showSkeleton = true;
      this.questionList = [];

      const ticket = this.ticket;
      let service = `${this.$store.state.api}/getState?ticket=${ticket}`;
      if (idx != null) {
        service += `&index=${idx}`;
      }
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      // this.$http
      //   .get(service, config)
      //   .then(respXhr => {
      //     if (respXhr.status == 200 && respXhr.data.status == true) {
      //       this.examState = respXhr.data.result;
      //       this.renderState();
      //     } else {
      //       this.onStateErr(false, respXhr.data);
      //     }
      //   })
      //   .catch(err => {
      //     // go to error page
      //     this.onStateErr(true, err);
      //   })
      //   .finally(() => {
      //     this.$vuetify.goTo(0);
      //     this.showSkeleton = false;
      //   });

          // console.log("attempt number", number);
        this.$http
        .get(service, config)
        .then((respXhr) => {
          if (respXhr.status == 200 && respXhr.data.status == true) {
            if (
              respXhr.data.requireScan != null &&
              respXhr.data.requireScan.length > 0
            ) {
              // set content if this is first load
              if (respXhr.data.result != null) {
                this.examState = respXhr.data.result;
              }
              this.renderState();
              // alert to scan on app
              try {
                // this.dialogRequireScan = true; // onyl test
                let payloadObj = {
                  ticketId: this.ticket,
                  jobs: respXhr.data.requireScan,
                };
                // console.log(payloadObj);
                if (typeof openFaceScanner !== "undefined") {
                  if (this.currentQuestion != null) {
                    let payloadStr = JSON.stringify(payloadObj);
                    openFaceScanner.postMessage(payloadStr);
                  } else {
                    alert("Can not get current question");
                  }
                } else {
                  this.dialogRequireScan = true;
                }

                this.requiredScanData = respXhr.data.requireScan; // array
              } catch (error) {
                // do nothing
                alert(JSON.stringify(error));
              }
            } else {
              this.examState = respXhr.data.result;
              this.renderState();
            }
            this.firstLoadStateSuccess = true
          } else {
            this.onStateErr(true, respXhr.data, idx);
          }
        })
        .catch((err) => {
          // go to error page
          if(err.response){
            this.onStateErr(true, err, idx);
          } else {
            this.onStateErr(false, err, idx);
          }
        })
        .finally(() => {
          this.$vuetify.goTo(0);
          this.showSkeleton = false;
        });

      //#region test
      // this.examState = {
      //   allowExam: true,
      //   answer: {
      //     answerPuzzle: [],
      //   },
      //   currtime: 0,
      //   endtime: 0,
      //   listQuestion: [
      //     {
      //       priority: 0,
      //       question: "5f44bc1a88511b24add654c8",
      //       state: null,
      //       typeQuestion: "crossword",
      //     },
      //     {
      //       priority: 1,
      //       question: "5f44bc1a88511b24add654c7",
      //       state: null,
      //       typeQuestion: "memorygame",
      //     },
      //     {
      //       priority: 2,
      //       question: "5f44bc1a88511b24add654c6",
      //       state: null,
      //       typeQuestion: "wordsearch",
      //     },
      //   ],
      //   question: {
      //     video: "",
      //     audio: "",
      //     question: "เกม Crossword",
      //     score: 20,
      //     priority: 0,
      //     typeQuestion: "wordsearch",
      //     _id: "5f44bc1a88511b24add654c8",
      //   },
      // };
      // setTimeout(() => {
      //   this.renderState();
      //   this.$vuetify.goTo(0);
      //   this.showSkeleton = false;
      // }, 1000);
      //#endregion
    },
    getQuestionList() {
      this.questionListAll = [];

      const ticket = this.ticket;
      let service = `${this.$store.state.api}/listQuestion?ticket=${ticket}`;
      // if (idx != null) {
      // service += `&index=1`;
      // }
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      // this.$http
      //   .get(service, config)
      //   .then(respXhr => {
      //     if (respXhr.status == 200 && respXhr.data.status == true) {
      //       this.questionListAll = respXhr.data.result.answer;
      //       console.log("question List", this.questionListAll);
      //       // this.renderState();
      //     } else {
      //       this.onStateErr(false, respXhr.data);
      //     }
      //   })
      //   .catch(err => {
      //     // go to error page
      //     this.onStateErr(true, err);
      //   })
      //   .finally(() => {
      //     // this.$vuetify.goTo("#app");
      //     // this.showSkeleton = false;
      //   });

      this.$http
        .get(service, config)
        .then((respXhr) => {
          if (respXhr.status == 200 && respXhr.data.status == true) {
            this.questionListAll = respXhr.data.result;
            this.firstLoadQuestionSuccess = true
            console.log("question List", this.questionListAll);
            // this.renderState();
          } else {
            this.onQuestionErr(true, respXhr.data);
          }
        }) 
        .catch((err) => {
          // go to error page
          if(err.response){
            this.onQuestionErr(true, err);
          } else {
            this.onQuestionErr(false, err);
          }
        });
    },
    renderState() {
      this.skipWithoutShowAnswer = false;

      this.questionList = this.examState.listQuestion.filter(
        (x) => x.typeQuestion != "article"
      );
      this.questionList = this.questionList.map((x) => {
        if (x.question == this.examState.question._id) x.current = true;
        else x.current = false;
        return x;
      });

      this.questionListForSelector = this.questionList;

      // when dom is updated
      // this.$nextTick().then(()=>{

      // })

      // check is readonly mode
      if (this.examState.summaryAns === true) {
        this.readonlyMode = true;
        this.$store.commit("setReadOnly", true);
        if (this.$store.state.showCorrectAnswer == true) {
          this.callShowAnswer();
        }
      } else {
        this.readonlyMode = false;
        this.$store.commit("setReadOnly", false);
        // check can do exam
        if (this.examState.allowExam == true) {
          // render state
          if (this.examState.currtime > 0) {
            //  && idx == null
            // first time access set timer
            this.setTimer();
          } else {
            this.clearTimer();
          }
        } else {
          this.summary();
        }
      }
    },
    onStateErr(fromCatch, err, idx) {
      this.hasTimer = false;
      // route to error page
      let data = err;
      let subError = "";
      console.log(this.firstLoadStateSuccess)
      if (!fromCatch && this.firstLoadStateSuccess) {
        this.errorTitle = "เกิดปัญหาการเชื่อมต่อ"
        this.errorDetail = "โปรดลองใหม่อีกครั้ง"
        this.canReturnToCourse = false
        this.connectionStateErr = true
      } else if(!this.firstLoadStateSuccess){
        if (err.response != null) {
          data = err.response.data;
          subError = ".001";
        } else {
          subError = ".002";
          data = { status: false, message: "Unexpected error" };
        }
        console.log("fistLoad go to red")
        
        this.$router.push({
          name: "error",
          params: {
            code: "0x001" + subError,
          },
        });
      } else {
        this.idx = idx
        this.errorTitle = "เกิดข้อผิดพลาดบางประการ"
        this.errorDetail = "กลับไปหน้าคอร์สเรียน"
        this.canReturnToCourse = true
        this.connectionStateErr = true
      }
    },
    onQuestionErr(fromCatch, err) {
      console.log(this.firstLoadQuestionSuccess)
      if(!fromCatch && this.firstLoadQuestionSuccess){
        this.errorTitle = "เกิดปัญหาการเชื่อมต่อ"
        this.errorDetail = "โปรดลองใหม่อีกครั้ง"
        this.connectionQuestionErr = true
      } else if(!this.firstLoadQuestionSuccess){
        
        console.log("fistLoad go to red")
        this.$router.push({
          name: "error",
          params: {
            code: "0x001" + ".001",
          },
        });
      } else {
        // this.$router.push({
        //   name: "error",
        //   params: {
        //     code: "0x001" + ".001",
        //   },
        // });
        // console.log("save error");
        this.errorTitle = "เกิดข้อผิดพลาดบางประการ"
        this.errorDetail = "โปรดลองใหม่อีกครั้ง"
        this.connectionQuestionErr = true
      }
    },
    confirmRetryQuestion(){
      this.connectionQuestionErr = false
      // this.getQuestionList()
      // this.summary()
    },
    onSendAnswerError(fromCatch, err) {
      if(!fromCatch){
        this.errorTitle = "เกิดปัญหาการเชื่อมต่อ"
        this.errorDetail = "โปรดลองใหม่อีกครั้ง"
        this.connectionSendAnswerErr = true
      } else {
        // this.$router.push({
        //   name: "error",
        //   params: {
        //     code: "0x001" + ".001",
        //   },
        // });
        this.errorTitle = "เกิดข้อผิดพลาดบางประการ"
        this.errorDetail = "โปรดลองใหม่อีกครั้ง"
        this.connectionSendAnswerErr = true
      }
    },
    confirmRetrySendAnswer(){
      this.connectionSendAnswerErr = false
      // this.saveAnswer()
      // this.summary()
    },
    confirmRetryStateErr(){
      this.connectionStateErr = false
      this.getState(this.idx)
      this.idx = null
      // this.saveAnswer()
      // this.summary()
    },
    closeWebView() {
      if (typeof closeExam !== "undefined") {
        closeExam.postMessage("true");
      } else {
        console.debug("not running inside a Flutter webview");
        window.opener.postMessage("close", "*");
        window.close();
      }
    },
    summary(nameDialog=null) {
      this.dialogConfirmEnd = false;
      this.hasTimer = false;
      // call summaryAns
      this.doProcess = true;
      this.processMsg = "กำลังสรุปผลการทดสอบ";
      this.$store.commit("setFinishExamBy", nameDialog);
      this.goSummaryPage();

      // setTimeout(() => {
      //   this.doProcess = false;
      //   // this.$router.push({ name: "summary" });
      // }, 1000 * 3);
      // console.log("summaryAns");
    },
    // call to server to send data
    sendAnswer(handler) {
      this.processMsg = "กำลังบันทึกคำตอบ";
      this.doProcess = true;

      var userAnswer = this.$refs.questionComp.getAnswer();
      //#region save to server
      const ticket = this.ticket;
      let service = `${this.$store.state.api}/ticketAnswer`;
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      let data = {
        idquestion: this.examState.question._id,
        ticket: ticket,
      };
      switch (this.examState.question.typeQuestion) {
        case "multiple":
          data.answer = userAnswer;
          break;
        case "single":
          data.answer = [userAnswer];
          break;
        case "fillgaptext":
          data.answerText = userAnswer;
          break;
        case "matchsome":
          data.answerMatch = userAnswer;
          break;
        case "memorygame":
          data.answerMemoryGame = userAnswer;
          break;
        case "crossword":
        case "wordsearch":
          data.answerPuzzleGrid = userAnswer;
          break;

        default:
          break;
      }
      this.$http
        .post(service, data, config)
        .then((resp) => {
          if (resp.status == 200) {
            let res = resp.data;
            if (res.status == true) {
              if (
                res.result.answer == true &&
                this.skipWithoutShowAnswer == false
              ) {
                this.alreadySave = true;
                // update question list
                let tmp = this.questionList.find(
                  (x) => x.question == data.idquestion
                );
                // console.log(tmp);
                if (tmp) {
                  tmp.state = "dummy-guid";
                }
                this.callShowAnswer();
              } else {
                // ทำแบบทดสอบต่อ
                if (res.result.allowExam) {
                  this.alreadySave = true;
                  let tmp = this.questionList.find(
                    (x) => x.question == data.idquestion
                  );
                  if (tmp) {
                    tmp.state = "dummy-guid";
                  }
                  if (handler) {
                    handler();
                  }
                } else {
                  // call summary
                  this.summary();
                }
              }
            } else {
              this.onSendAnswerError(true);
            }
          } else {
            this.onSendAnswerError(true);
          }
        })
        .catch((err) => {
          // go to error page
          if(err.response){
            this.onSendAnswerError(true);
          } else {
            this.onSendAnswerError(false);
          }
        })
        .finally(() => {
          this.doProcess = false;
        });
      //#endregion

      // console.log(data);
      // setTimeout(() => {
      //   this.doProcess = false;
      //   if (handler) {
      //     handler();
      //   }
      // }, 1000 * 3);
    },
    next() {
      if (this.examState.summaryAns == true || this.alreadySave) {
        if (this.changeQuestionByArrow(1) == 9) {
          this.goSummaryPage();
        }
      } else {
        this.detectChanges("arrow", 1);
      }
    },
    prev() {
      if (this.examState.summaryAns == true || this.alreadySave) {
        this.changeQuestionByArrow(-1);
      } else {
        this.detectChanges("arrow", -1);
      }
    },
    goSummaryPage() {
      // this.$router.push({
      //   name: "summary",
      //   params: { id: this.ticket },
      // });
      this.$router.push({
        name: "summaryNoParam",
      });
    },
    showSelectQuestion() {},
    detectChanges(src, navValue) {
      let userAnswer = this.$refs.questionComp.getAnswer();

      // check is already save to server?
      //#region check is saved and answer change
      const q = this.questionList.find(
        (x) => x.question == this.examState.question._id
      );

      if (q.state != null) {
        // additional check answer change , but now can alway can skip?
        if (
          this.$answerChanged(
            this.examState.question.typeQuestion,
            this.currentAnswer,
            userAnswer
          ) == false
        ) {
          if (src == "selector") {
            this.getState(navValue);
          } else {
            if (this.changeQuestionByArrow(navValue) == 9) {
              //alert("last q");
              // this.goSummaryPage();
            }
          }
          return;
        }
      }
      //#endregion
      // console.log(userAnswer);
      if (this.$hasAnswer(this.examState.question.typeQuestion, userAnswer)) {
        this.dialogSaveChanges_source = src;
        this.dialogSaveChanges_value = navValue;
        this.dialogSaveChanges = true;
      } else {
        if (src == "selector") {
          this.getState(navValue);
        } else {
          this.changeQuestionByArrow(navValue);
        }
      }
    },
    changeQuestionByArrow(value) {
      let priority = this.examState.question.priority;
      const currentIdx = this.questionList.findIndex(
        (x) => x.priority == priority
      );

      // flying check
      if (this.questionList[currentIdx + value]) {
        const nextQ = this.questionList[currentIdx + value];
        this.getState(nextQ.priority);
        return 1; // change q
      } else {
        if (value == 1) {
          //alert("last q");
          return 9; // last
        } else {
          //alert("first q");
          return 0; // first
        }
      }
    },
    // call by button
    saveAnswer() {
      this.skipWithoutShowAnswer = false;
      this.sendAnswer(() => {
        this.changeQuestionByArrow(1);
        setTimeout(() => {
          if (this.allDone) {
            this.endExam();
          }
        }, 500);
      });
    },
    skipQuestion() {
      this.dialogSaveChanges = false;
      if (this.dialogSaveChanges_source == "selector") {
        this.getState(this.dialogSaveChanges_value);
      } else {
        this.changeQuestionByArrow(this.dialogSaveChanges_value);
      }
    },
    saveBeforeChange() {
      this.skipWithoutShowAnswer = true;
      this.dialogSaveChanges = false;
      this.sendAnswer(this.skipQuestion);
    },
  },
};
</script>

<style lang="scss">
.v-toolbar {
  background: #efefef !important;
  flex-grow: 0;

  .v-toolbar__content {
    padding: 8px;
  }
}

.v-content {
  max-height: calc(100vh - 52px);
  overflow: auto;
}

.question-block {
  margin: 0 auto;
  // padding: 24px 32px;
  padding: 16px 16px;
  background: #fff;
  border-radius: 8px;
}

.btn-group {
  display: flex;
  align-items: center;
  justify-content: center;

  .v-btn--depressed {
    margin: 0 24px;
  }
}

.prev-btn,
.next-btn {
  position: absolute;
  top: 4px;

  &:not(:disabled) {
    background: rgba(0, 0, 0, 0.03);
  }
}
.prev-btn {
  left: -8px;
}
.next-btn {
  right: -8px;
}
</style>